/**
 * Formats a numeric string value to a specified number of decimal places.
 * 
 * @param value - The string value to format
 * @param decimalPlaces - Number of decimal places (default: 4)
 * @returns Formatted string with specified decimal places, or '—' if value is invalid
 */
export function formatValue(value: string | undefined, decimalPlaces: number = 2): string {
  if (!value || value === '—') {
    return '—';
  }
  const numValue = Number(value);
  return isNaN(numValue) ? '—' : numValue.toFixed(decimalPlaces);
}

/**
 * Formats a number to scientific notation string (e.g. 1.23e+4).
 *
 * @param value - The number to format
 * @param significantDigits - Number of significant digits after the decimal (default: 3)
 * @returns Scientific notation string, or '—' if value is null/undefined/NaN
 */
export function toScientificNotation(value: number | null | undefined, significantDigits: number = 2): string {
  if (value == null || isNaN(value)) return '—';
  return value.toExponential(significantDigits);
}

/**
 * Removes the file extension from a filename.
 * 
 * @param fileName - The filename to process
 * @returns Filename without extension, or empty string if fileName is undefined
 */
export function getFileNameWithoutExtension(fileName: string | undefined): string {
  if (!fileName) return '';
  
  const lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex === -1 ? fileName : fileName.substring(0, lastDotIndex);
}
